module.exports = __webpack_public_path__ + "static/media/Thunderstorm.c16a809c.jpg";